export default "__VITE_ASSET__CW7G9dYz__"